export default {"src":"/_next/static/media/CNP.e7fb6e86.svg","height":18,"width":18};